import {
  SettingsPermissions,
  UserPermissions,
} from "@redotech/account-common/permissions";
import { TeamContextValue } from "@redotech/redo-web/context/team-context";
import { parseOnboardingPreviewType } from "./onboarding-preview";

type TeamType = NonNullable<TeamContextValue>;

export function isReturnsEnabled(team: TeamType): boolean {
  return team.settings.returns?.enabled === true;
}

export function canManageInternationalReturnsSettings(
  permissions: Set<UserPermissions> | undefined,
): boolean {
  return (
    permissions?.has(SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS) ===
      true ||
    permissions?.has(SettingsPermissions.SET_SHIPPING_SETTINGS) === true
  );
}

const INTERNATIONAL_RETURNS_SETTINGS_PATH = "/settings/international/returns";

export function isOnInternationalReturnsSettingsPage(
  pathname: string,
): boolean {
  const index = pathname.indexOf(INTERNATIONAL_RETURNS_SETTINGS_PATH);
  if (index === -1) {
    return false;
  }

  const suffix = pathname.slice(
    index + INTERNATIONAL_RETURNS_SETTINGS_PATH.length,
  );
  return suffix === "" || suffix.startsWith("/");
}

export function isEligibleForInternationalReturnsCustomsPopup(
  team: TeamType,
  permissions: Set<UserPermissions> | undefined,
  pathname: string,
  search = "",
): boolean {
  if (
    typeof navigator !== "undefined" &&
    navigator.webdriver &&
    parseOnboardingPreviewType(search) === null
  ) {
    return false;
  }

  if (!isReturnsEnabled(team)) {
    return false;
  }

  if (!canManageInternationalReturnsSettings(permissions)) {
    return false;
  }

  if (isOnInternationalReturnsSettingsPage(pathname)) {
    return false;
  }

  return true;
}
